import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, RadioCardButton } from 'veloe-ds';
import PropTypes from 'prop-types';
import { getData } from '../../api/dataAPI';
import { salvarReceberAdesivo } from '../../actions/pedidoActions';
import { APP_PAGES } from '../../routes';
import { receberAdesivoAsync } from '../../actions/asyncActions';
import { veloeGraphQlApi } from '../../api/graphql/graphQLAPI';
import produtoFCG from '../../mutations/produto';
import { withSnackbar } from 'notistack';
import ScriptTag from 'react-script-tag';
import { modalInformativo } from '../../Components/Modais';
import { eventTrackBasic, eventTrackRoute } from '../../utils/pushDataLayer.js';

/**
 * Exibe as opções de receber o adesivo ou não e salva a opção selecionada pelo cliente
 *
 * A lista de receber adesivo é composta por:
 *
 *  id (inteiro)
 *  título (string com o opcao sim ou nao)
 *  texto (string explicando a opcao)
 *
 * A váriavel botaoContinuar indica se o botão será apresentado na tela (true) ou se o click no card irá para o proximo passo (false - atual)
 * Após a escolha salva o id e o título no dicionário receberAdesivo
 * */
class ReceberAdesivo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      botaoContinuar: true,
      codigoPromocional: this.props.pedido.codigoPromocional,
      receberAdesivo: this.props.pedido.receberAdesivo,
      list: getData('listReceberAdesivo'),
    };
  }
  componentDidMount = () => {
    const { pedido, history } = this.props;
    this.selecionaReceberAdesivo(pedido.receberAdesivo);
    this.manterCheckbox(pedido.receberAdesivo);
    const proposta = JSON.parse(localStorage.getItem('proposta'));

    if (!proposta) {
      history.push(APP_PAGES.CADASTRO);
    }
    eventTrackRoute('receber-produto');
  };

  selecionaReceberAdesivo = (item) => {
    if (item === 'sim' || item === 'nao') {
      eventTrackBasic('clique:opcao', `deseja-receber-adesivo:${item}`);
      this.setState({ receberAdesivo: item, botaoContinuar: false });
      this.manterCheckbox(item);
    }
  };
  manterCheckbox(itemID) {
    const { list } = this.state;

    Object.keys(list).forEach((key) => {
      list[key].checkbox = list[key].id === itemID;
      this.setState({ list });
    });
  }

  async chamaFuncRand() {
    const { salvarReceberAdesivo, activeLoader, inactiveLoader } = this.props;
    const { receberAdesivo } = this.state;

    const reCaptcha = await window.grecaptcha.execute(
      process.env.REACT_APP_KEY_RECAPTCHA,
      {
        action: 'homepage',
      },
    );

    activeLoader();

    const proposta = JSON.parse(localStorage.getItem('proposta'));
    veloeGraphQlApi(produtoFCG, {
      idProposta: proposta.dados.id,
      tipoProduto: 'STICKER',
      tagEmMaos: receberAdesivo === 'nao',
      captchaResponse: reCaptcha,
    })
      .then((data) => {
        const { dados, validatorResponse } = data['produtoFCG'];
        if (dados) {
          salvarReceberAdesivo(receberAdesivo);
          localStorage.setItem(
            'proposta',
            JSON.stringify({
              ...(data['produtoFCG'] || ''),
              ...proposta,
              tagEmMaos: receberAdesivo === 'nao',
              tipoProduto: 'STICKER',
            }),
          );
          inactiveLoader();
          this.props.history.push(APP_PAGES.QTD_PRODUTO);
        } else {
          const { errors } = validatorResponse;
          inactiveLoader();
          return errors.map((error) =>
            this.setState({
              textoTermos: error.message,
              openModalInformativo: true,
            }),
          );
        }
      })
      .catch((err) => {
        inactiveLoader();
        this.setState({
          textoTermos: err.message,
          openModalInformativo: true,
        });
      });
  }

  renderizaRadioButtons = () => {
    const { list } = this.state;
    const values = list.map((item) => ({
      id: item.id,
      key: `value-${item.id}`,
      value: (
        <div className="containerCard">
          <div className="containerTextCard">
            <span className="tituloCard">{item.titulo}</span>
            <span className="textoCard">{item.texto}</span>
          </div>
        </div>
      ),
    }));

    return (
      <RadioCardButton
        key="radio-cards"
        values={values}
        onBg="light"
        cardSize="lg"
        value={this.state.receberAdesivo}
        onChange={(value) => {
          this.selecionaReceberAdesivo(value);
        }}
      />
    );
  };

  render() {
    return (
      <div className="containerComponent">
        <div className="containerText">
          <div className="containerLabel">
            <div className="areaTexto">
              Você deseja receber um adesivo Veloe?
            </div>
          </div>
        </div>
        <div className="containerArea">
          <div className="containerOndeUsar">
            {this.renderizaRadioButtons()}
            <Button
              className="stack-button"
              {...{
                onBg: 'light',
                color: 'primary',
                disabled: this.state.botaoContinuar,
                label: 'Continuar',
                id: 'btn-continuar',
              }}
              onClick={() => this.chamaFuncRand()}
            />
          </div>
        </div>
        {this.state.openModalInformativo &&
          modalInformativo(
            true,
            () => {
              this.setState({ openModalInformativo: false });
            },
            'Ops!',
            this.state.textoTermos,
          )}
        <ScriptTag
          type="text/javascript"
          src={`https://www.google.com/recaptcha/api.js?render=${process.env.REACT_APP_KEY_RECAPTCHA}`}
        />
      </div>
    );
  }
}

const mapStateToProps = ({ pedido }) => {
  return { pedido };
};

const mapDispatchToProps = (dispatch) => {
  return {
    salvarReceberAdesivo: (option) => dispatch(salvarReceberAdesivo(option)),
    receberAdesivoAsync: (option) => dispatch(receberAdesivoAsync(option)),
    activeLoader: () => dispatch({ type: 'loader_active' }),
    inactiveLoader: () => dispatch({ type: 'loader_inactive' }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withSnackbar(ReceberAdesivo));

ReceberAdesivo.propTypes = {
  pedido: PropTypes.shape({
    tipoVeiculo: PropTypes.string,
    receberAdesivo: PropTypes.string,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
};
